export default __webpack_public_path__ + "static/media/storybook.4baf9f31.svg";